export default {
    set(state, payload) {
        payload.panel.responses = payload.responses
    }
}
